"use client"

import { useEffect, useState } from "react"

const TextRing = ({ children, side }) => {
    const [CHARS, setCHARS] = useState<any>([])
    useEffect(()=>{
        if(children){
            
            if(typeof children === "string"){
                setCHARS(children.split(''))
            } else if (typeof children === "object") {
                setCHARS(children)
            }
        }
    }, [])
    const [INNER_ANGLE, setINNER_ANGLE] = useState<any>()
    useEffect(()=>{
        if(CHARS){
            setINNER_ANGLE(360 / CHARS.length)
        }
    }, [CHARS])
    return (
        <span
            className="text-ring"
            style={{
                '--total': CHARS.length,
                '--radius': side / Math.sin(INNER_ANGLE / (180 / Math.PI))
            } as any}
        >
            {CHARS.map((char, index) => (
                <span key={index} style={{ '--index': index } as any}>
                    {char}
                </span>
            ))}
        </span>
    )
}

export default TextRing
